import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type QualysConnectorConfig = typeof QualysConnector._.Config;

export const QualysConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Qualys,
  logoPath: 'images/qualys-logo.svg',
  categories: [IntegrationConnectorCategory.Security],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.Password,
      configSchema: z.object({
        baseUrl: z.url(),
        username: z.string().min(1),
      }),
      encryptedConfigSchema: z.object({
        password: z.string().min(1),
      }),
    }),
  ]),
});
